import { NavLink, Outlet } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { Tabs } from "@/components/molecules";
import { useCanManageAsAssistant } from "@/components/organisms/ClientHeader/ClientNavLinks";
import { clsx } from "@/utils";

const baseSettingsLinks = [
  { name: "My Profile", to: "profile" },
  { name: "Email Notifications", to: "notifications" },
  { name: "Assistants", to: "assistants" },
  { name: "Payment Settings", to: "payments" },
];

export const ClientSettings = () => {
  // An EA (Executive Assistant / Travel Manager) can't have an assistant of their own, so hide the
  // "Assistants" tab on their own profile. Regular clients still see it.
  const isAssistant = useCanManageAsAssistant();
  const settingsLinks = baseSettingsLinks.filter((link) => link.to !== "assistants" || !isAssistant);

  return (
    // Cap + centre so the settings card doesn't stretch full-width on ultrawide (DEV-1366). 1164px
    // matches the Figma Settings frame at 2560 (DSN-558, node 6476-18581) and mirrors My Clients; a
    // no-op below that width, so tablet/mobile are unchanged (mx-auto gives the old 138px margins at 1440).
    <div className="mx-auto w-full max-w-[1164px] px-5 py-6 md:px-8">
      <Typography variant="h2">Settings</Typography>

      <div className="mt-3 lg:hidden">
        <Tabs tabs={settingsLinks} mobileVariant="sheet" />
      </div>

      <div className="mt-3 rounded-lg border border-neutral-mid-gray bg-white lg:flex">
        <nav className="hidden shrink-0 flex-col border-r border-neutral-gray p-5 lg:flex" aria-label="Settings">
          {settingsLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                clsx("rounded-lg px-4 py-3 transition-colors", {
                  "bg-primary-light": isActive,
                  "hover:bg-neutral-surface-gray": !isActive,
                })
              }
            >
              {({ isActive }) => (
                <Typography
                  variant={isActive ? "action" : "paragraph"}
                  className={clsx("!m-0 whitespace-nowrap", isActive ? "text-primary" : "text-neutral-black")}
                >
                  {link.name}
                </Typography>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="min-w-0 flex-1 p-5">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
